/* eslint-disable */
import type { DatePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import { convertDDMMYYYToYYYYMMDD } from 'common/utils/functions';
import { RangePickerProps } from 'antd/es/date-picker';

export type DatePickerComponentProps = {
  error?: string;
  disableDateUnder18age?: boolean;
} & DatePickerProps;

const eighteenYearsAgo = dayjs().subtract(18, 'year');

export const Picker = (props: DatePickerComponentProps) => {
  const disabledDateUnder18age: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days before today and today
    return current && current.isAfter(eighteenYearsAgo, 'day');
  };

  return (
    <>
      <DatePicker
        {...props}
        onChange={props.onChange}
        style={{ width: '100%' }}
        defaultPickerValue={props.defaultPickerValue ?? props.disableDateUnder18age ? eighteenYearsAgo : undefined}
        disabledDate={props.disableDateUnder18age ? disabledDateUnder18age : props.disabledDate}
        onBlur={(e) => {
          if (props.onChange) {
            const v = e.currentTarget.value ? dayjs(convertDDMMYYYToYYYYMMDD(e.currentTarget.value)) : null;
            props.onChange(v, e.currentTarget.value);
          }
        }}
      />
      {props.error && (
        <span
          className="a-input_errorMessage"
        >
          {props.error}
        </span>
      )}
    </>
  );
};
